import { createTheme } from '@mui/material/styles';

// Create a theme instance — see DESIGN.md for product-facing rationale.
const theme = createTheme({
  palette: {
    primary: {
      main: '#00675b',
    },
    secondary: {
      main: '#b0003a',
    },
    error: {
      main: '#ba000d',
    },
    warning: {
      main: '#c41c00',
    },
    info: {
      main: '#3f51b5',
    },
    success: {
      main: '#087f23',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: [
      'Montserrat',
      'Noto Sans HK',
      'Noto Sans TC',
      'Roboto',
      'Helvetica Neue',
      'Helvetica',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontSize: 16,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: false,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

export default theme;